<template>
  <div class="page page--fill">
    <data-list
      title="Ventes"
      :resource="resource"
      :columns="columns"
      :filters="filters">
      <template #summary>
        <kpi-row :items="kpis" />
      </template>
      <template #ref="{ item }">
        <span class="cell-mono">{{ item.ref }}</span>
      </template>
      <template #status="{ item }">
        <span :class="pillClass(RESERVATION_STATUS, item.status)">{{ labelOf(RESERVATION_STATUS, item.status) }}</span>
      </template>
      <template #program="{ item }">
        <div class="cell-strong">
          {{ item.program && item.program.name }}
        </div>
        <div class="cell-muted">
          Lot {{ item.lot && item.lot.ref }}
        </div>
      </template>
      <template #promoteur="{ item }">
        <router-link
          v-if="item.promoteur"
          class="cell-link"
          :to="{ name: 'accountVue', params: { id: item.promoteur.pk } }"
          @click.native.stop>
          {{ item.promoteur.name }}
        </router-link>
      </template>
      <template #user="{ item }">
        <template v-if="item.user">
          <div>{{ item.user.first_name }} {{ item.user.last_name }}</div>
          <div class="cell-muted">
            {{ item.account && item.account.name }}
          </div>
        </template>
        <span v-else>—</span>
      </template>
      <template #contact="{ item }">
        {{ item.contact ? `${item.contact.first_name || ''} ${item.contact.last_name || ''}` : '—' }}
      </template>
      <template #use_electronic_signature="{ item }">
        <v-icon
          v-if="item.use_electronic_signature"
          small
          color="primary"
          title="Signature électronique">
          mdi-signature-freehand
        </v-icon>
      </template>
    </data-list>
  </div>
</template>

<script>
  import RESOURCES from '@batimentb/vadimm-js-api/resources'
  import DataList from '../components/DataList'
  import KpiRow from '../components/KpiRow'
  import { RESERVATION_STATUS, YES_NO, toOptions, pillClass, labelOf, formatDate } from '../labels'

  export default {
    name: 'ReservationList',
    components: { DataList, KpiRow },
    data () {
      return {
        kpis: [
          { label: 'Ventes', resource: RESOURCES.RESERVATION, params: {} },
          { label: 'Pré-réservées', resource: RESOURCES.RESERVATION, params: { status: 'pre_reserved' } },
          { label: 'Réservées', resource: RESOURCES.RESERVATION, params: { status: 'reserved' } },
          { label: 'Vendues', resource: RESOURCES.RESERVATION, params: { status: 'sold' } },
          { label: 'Annulées', resource: RESOURCES.RESERVATION, params: { status: 'canceled' } }
        ],
        RESERVATION_STATUS,
        resource: RESOURCES.RESERVATION,
        columns: [
          { key: 'ref', label: 'Réf.', width: 110 },
          { key: 'status', label: 'Statut', width: 140 },
          { key: 'program', label: 'Programme / lot' },
          { key: 'promoteur', label: 'Promoteur' },
          { key: 'user', label: 'Vendeur' },
          { key: 'contact', label: 'Acquéreur' },
          { key: 'use_electronic_signature', label: 'E-sign', width: 70, align: 'center' },
          { key: 'created_on', label: 'Créée le', width: 110, format: formatDate }
        ],
        filters: [
          { key: 'searchable_name', type: 'search', label: 'Rechercher (réf., acquéreur…)' },
          { key: 'status', type: 'select', label: 'Statut', items: toOptions(RESERVATION_STATUS) },
          { key: 'promoteur', type: 'remote', label: 'Promoteur', resource: RESOURCES.ACCOUNT },
          { key: 'account', type: 'remote', label: 'Compte vendeur', resource: RESOURCES.ACCOUNT },
          { key: 'use_electronic_signature', type: 'select', label: 'Signature électronique', items: YES_NO }
        ]
      }
    },
    methods: {
      pillClass,
      labelOf
    }
  }
</script>
